/* eslint-disable  @typescript-eslint/no-non-null-assertion */
import { html, unsafeCSS } from 'lit';
import { property, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { LeafElement } from '@cigna/dcws_leaf-web-components/components/leaf-element.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { I18nMixin } from '../../utils/i18n-mixin.js';
import { MrfData, MachineReadableJson } from './interfaces.js';
import styles from './machine-readable-files.scss?inline';

export class CHCMachineReadableFiles extends I18nMixin(LeafElement) {
  static override styles = unsafeCSS(styles);
  protected override ns = 'machine-readable-files';
  private machineReadableJson?: MachineReadableJson;

  @property({ reflect: true })
  src!: string;

  @property({ reflect: true })
  stateFile: string = 'default';

  @state()
  fetchedData?: MrfData;

  override onNamespacesLoaded = () => {
    this.machineReadableJson = this.i18n?.getLanguageData(this.ns) as MachineReadableJson;
  };

  protected override async firstUpdated() {
    await this.updateComplete;
    const response = await fetch(this.src);
    this.fetchedData = (await response.json()) as MrfData;
  }

  renderMarkup() {
    if (this.fetchedData) {
      return html` <a href="${ifDefined(this.fetchedData?.mrfs[0].files[0].url)}" target="_blank"
          >${unsafeHTML(this.machineReadableJson![this.stateFile]?.clickHere)}</a
        >${unsafeHTML(this.machineReadableJson![this.stateFile]?.clickHereText)}`;
    }
    return html`<slot name="error"></slot>`;
  }

  override render() {
    const loadingOrError = this.renderLoadingOrError();
    if (loadingOrError) {
      return loadingOrError;
    }
    return html`<div class="chcapp-machine-readable-files">${this.renderMarkup()}</div> `;
  }
}
